import React from 'react'

import { BaseBatchTransactions } from './BaseBatchTransactions'

interface Props {}

export function RefundTransactions (_props: Props) {
  return (
    <BaseBatchTransactions
      searchType='refundable'
      action='refund'
      helpLink='https://paytrace.atlassian.net/wiki/spaces/HD/pages/2025783819/Refund+Transactions'
      title='Refund Transactions'
    />
  )
}

export default RefundTransactions
